<template>
  <div class="">
    <div v-if="isLoading" class="loading apollo">Loading...</div>
    <div v-else>
      <nav
        id="mainNavbar"
        class="uk-navbar-container"
        style="background-color: black"
        uk-navbar
      >
        <a
          class="uk-margin-left uk-margin-top logo uk-text-left"
          href="https://contrak.us"
          target="_blank"
          style="color: white"
        >
          contrak
        </a>
        <h2
          class="uk-margin-left uk-margin-top uk-text-left"
          style="color: white"
        >
          |
        </h2>
        <h2
          class="uk-margin-left uk-margin-top uk-text-left"
          style="color: white"
        >
          Customer Portal
        </h2>
      </nav>
      <h2>Orders for: {{ customer.name }}</h2>

      <button class="uk-button uk-button-default" @click="selFilter('active')">
        Active Orders
        <span class="uk-badge uk-label-green">{{ activeOrders.length }}</span>
      </button>
      <button
        class="uk-button uk-button-default"
        @click="selFilter('complete')"
      >
        Completed Orders
        <span class="uk-badge uk-label-orange">{{
          completedOrders.length
        }}</span>
      </button>

      <table class="uk-table uk-table-striped uk-table-hover uk-table-small ">
        <thead>
          <tr>
            <th @click="updateSortBy('orderId')">
              Order Reference
              <span
                v-if="sortBy == 'orderId'"
                uk-icon="icon:triangle-down"
              ></span>
            </th>
            <th @click="updateSortBy('orderId')">
              Carrier Reference
              <span
                v-if="sortBy == 'orderId'"
                uk-icon="icon:triangle-down"
              ></span>
            </th>
            <th @click="updateSortBy('createdOn')">
              Created On
              <span
                v-if="sortBy == 'createdOn'"
                uk-icon="icon:triangle-down"
              ></span>
            </th>
            <th>Export/Import</th>
            <th @click="updateSortBy('receiver')">
              Receiver Name
              <span
                v-if="sortBy == 'receiver'"
                uk-icon="icon:triangle-down"
              ></span>
            </th>
            <th @click="updateSortBy('billing')">
              Carrier
              <span
                v-if="sortBy == 'billing'"
                uk-icon="icon:triangle-down"
              ></span>
            </th>
            <th @click="updateSortBy('status')">
              Status
              <span
                v-if="sortBy == 'status'"
                uk-icon="icon:triangle-down"
              ></span>
            </th>
            <!-- <th>Accepted</th> -->
            <th @click="updateSortBy('bl')">
              Bill Of Lading
              <span v-if="sortBy == 'bl'" uk-icon="icon:triangle-down"></span>
            </th>
            <th>
              # Containers
              <span
                v-if="sortBy == 'nContainers'"
                uk-icon="icon:triangle-down"
              ></span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(order, orderIdx) in billingOrders"
            :key="orderIdx"
            v-on:click="selectOrder(order.id)"
          >
            <td class="uk-text-left">{{ order.billingReferenceNumber }}</td>
            <td class="uk-text-left">{{ order.id }}</td>
            <td class="uk-text-left">{{ order.createdAt }}</td>
            <td class="uk-text-left" v-if="order.isExport">
              <span class="uk-label uk-label-warning">Export</span>
            </td>
            <td class="uk-text-left" v-else>
              <span class="uk-label uk-label-light-blue">Import</span>
            </td>
            <td class="uk-text-left" v-if="order.customer">
              {{ order.customer.name }}
            </td>
            <td class="uk-text-left" v-else-if="order.receiver" :uk-tooltip="fullAddress(order.receiver.address)">
              {{ `${order.receiver.name} (${order.receiver.address.city})` }}
            </td>
            <td class="uk-text-left" v-if="order.company">
              {{ order.company.name }}
            </td>

            <!-- status  -->
            <td class="uk-text-left" v-if="!order.status">
              <span class="uk-label uk-label-warning">Unknown</span>
            </td>
            <td class="uk-text-left">
              <span v-if="!order.status" class="uk-label uk-label-warning"
                >Unknown</span
              >
              <span
                v-else-if="order.status == 'Complete'"
                class="uk-label uk-label-orange"
                >Complete</span
              >
              <span
                v-else-if="order.status === 'In Progress'"
                class="uk-label uk-label-success"
              >
                {{ order.status }}
              </span>
              <span v-else-if="order.status === 'Not Available'" class="uk-label uk-label-danger"
                >Not Available</span
              >
              <span v-else-if="order.status === 'Cancelled'" class="uk-label uk-label-danger"
                >Cancelled</span
              >
              <span v-else class="uk-label">
                {{ order.status }}
              </span>
            </td>

            <!-- accepted state  -->
            <!-- Temporarily removing this until we figure out how to incoprorate with new Avaialbility logic -->
            <!-- <td v-if="!order.acceptedState || order.acceptedState === 'Not Accepted'">
          <span class="uk-label uk-label-danger">Not Accepted</span>
        </td>
        <td v-else-if="order.acceptedState === 'Rejected'">
          <span class="uk-label uk-label-stale">Rejected</span>
        </td>
        <td v-else-if="order.acceptedState === 'In Progress'">
          <span class="uk-label uk-label-warning">In Progres</span>
        </td>
        <td v-else-if="order.acceptedState === 'Accepted'">
          <span class="uk-label uk-label-success">Accepted</span>
        </td>
        <td v-else-if="order.acceptedState === 'Completed'">
          <span class="uk-label uk-label-success">Completed</span>
        </td>
        <td v-else>
          <span class="uk-label">{{order.acceptedState}}</span>
        </td>-->

            <!-- bill of lading  -->
            <td class="uk-text-left" v-if="order.isExport">
              {{ order.bookingNumber }}
            </td>
            <td class="uk-text-left" v-else-if="order.billOfLading">
              {{ order.billOfLading.billOfLadingId }}
            </td>
            <td class="uk-text-left" v-else>N/A</td>

            <!-- containers  -->
            <td class="uk-text-left">{{ order.containers.length }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import sort from 'fast-sort';
import OrderCustomer from '@/gql/customers/query/external/OrderCustomer.gql';
import { addressMixin } from '../../../utils/address';

export default defineComponent({
  data() {
    return {
      sortBy: 'id',
      filter: 'active',
    };
  },
  mixins: [addressMixin],
  methods: {
    selectOrder(orderId) {
      (this as any).$router.push(`/status/order/${btoa(orderId)}`);
    },
    selFilter(filter) {
      this.filter = filter;
    },
  },
  computed: {
    sortedOrders(): any[] {
      const ordersSource = (this as any).customer && Array.isArray((this as any).customer.billingOrders)
        ? (this as any).customer.billingOrders.slice()
        : [];

      return sort(ordersSource).desc((u: any) => u.id);
    },
    completedOrders(): any[] {
      return (this as any).customer.billingOrders.filter(
        (x: any) => x.status === 'Complete',
      );
    },
    activeOrders(): any[] {
      return (this as any).customer.billingOrders.filter(
        (x: any) => x.status !== 'Complete',
      );
    },
    billingOrders(): any[] {
      if (this.filter === 'complete') {
        return sort(
          this.sortedOrders.filter((x: any) => x.status === 'Complete'),
        ).desc((u: any) => Number(u.id));
      } else {
        return sort(
          this.sortedOrders.filter((x: any) => x.status !== 'Complete'),
        ).desc((u: any) => Number(u.id));
      }
    },
    isLoading(): boolean {
      return (this as any).$apollo.queries.customer.loading;
    },
    customerId(): string | undefined {
      const vm = (this as any);

      if (vm.$route.params.hash) {
        return atob(vm.$route.params.hash);
      }

      return undefined;
    },
  },
  ...{
    apollo: {
      customer: {
        query: OrderCustomer,
        variables() {
          return {
            id: (this as any).customerId,
          };
        },
        pollInterval: 30000,
        skip() {
          const vm = (this as any);
          return !vm || !vm.$route || !vm.customerId;
        },
      },
    },
  },
});
</script>